<template>
  <div>
    <div style="display: flex">
      <b-form-radio-group
        id="radio-group-model"
        class="m-2"
        buttons
        v-model="modelType"
        size="lg"
        button-variant="primary"
      >
        <b-form-radio variant="primary" value="climate"
          >Regionális klíma</b-form-radio
        >
        <b-form-radio variant="primary" value="city">Városi klíma</b-form-radio>
      </b-form-radio-group>

      <b-form-radio-group
        id="radio-group-view"
        class="m-2"
        buttons
        v-model="viewType"
        size="lg"
        button-variant="primary"
      >
        <b-form-radio value="mapView">Térképi nézet</b-form-radio>
        <b-form-radio value="graphView">Grafikon nézet</b-form-radio>
      </b-form-radio-group>

      <b-form-checkbox
        class="m-3"
        v-model="compare"
        v-show="viewType == 'mapView'"
        switch
        size="lg"
        button-variant="primary"
        title="Két térkép összehasonlítása egymás mellett"
        v-b-tooltip.hover
      >
        Összehasonlítás</b-form-checkbox
      >
      <!--<b-button
        variant="primary"
        v-if="!$store.state.parameterStripe.outPdfLink && viewType == 'mapView'"
        :disabled="isPrintButtonDisabled || definitionQuery1 == '' || compare"
        class="m-2 nyomtat"
        @click="print"
        >Nyomtatás</b-button
      >-->
      <b-dropdown
        id="saveDropdown"
        text="Térkép mentése"
        class="m-2"
        variant="primary"
        v-if="!$store.state.parameterStripe.outPdfLink && viewType == 'mapView'"
        :disabled="isPrintButtonDisabled || definitionQuery1 == '' || compare"
        title="Az eredmény letöltése pdf vagy geotiff formátumban"
        v-b-tooltip.hover
      >
        <b-dropdown-item @click="print()">PDF nyomtatás</b-dropdown-item>
        <b-dropdown-item @click="saveGeoTiff()"
          >Georeferált TIF</b-dropdown-item
        >
      </b-dropdown>
      <!--<b-link
        class="m-2 nyomtat"
        v-if="$store.state.parameterStripe.outPdfLink && viewType == 'mapView'"
        :href="$store.state.parameterStripe.outPdfLink"
        target="_blank"
        @click="
          $store.state.parameterStripe.outPdfLink = undefined;
          isPrintButtonDisabled = false;
        "
        >PDF letöltése</b-link
      >-->
    </div>

    <div id="RasterParameterContainer">
      <parameter-container
        class="rightPlaceHolder m-2"
        :viewType="viewType"
        :modelType="modelType"
        :variableMap="variableMap"
        :qSubTypeMap="qSubTypeMap"
        :aggregationModeForGraph="aggregationModeForGraph"
        :containerNumber="1"
        :compare="compare"
      ></parameter-container>

      <parameter-container
        class="rightPlaceHolder m-2"
        :viewType="viewType"
        :modelType="modelType"
        :variableMap="variableMap"
        :qSubTypeMap="qSubTypeMap"
        :aggregationModeForGraph="aggregationModeForGraph"
        v-show="showSecondRow && viewType == 'mapView'"
        :containerNumber="2"
        :compare="compare"
      ></parameter-container>
      <div
        v-show="!(showSecondRow && viewType == 'mapView')"
        class="rightPlaceHolder"
      ></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { config } from "@/config/config.js";
import AggregationModeSelector from "@/components/AggregationModeSelector.vue";
import Multiselect from "vue-multiselect";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { loadModules } from "esri-loader";
import ParameterContainer from "@/components/ParameterContainer.vue";

export default {
  name: "ParameterStripe",
  components: {
    AggregationModeSelector,
    Multiselect,
    VueSlider,
    ParameterContainer,
  },
  props: {
    /*dateRangeStart: Number,
    dateRangeStart2: Number,*/
  },
  watch: {
    compare: function (val) {
      if (val) {
        //itt minden beállítást át kellene venni
        this.mode2 = this.mode1;
        //this.paramProbability2 = this.paramProbability1;
        //this.paramDifference2 = this.paramDifference1;
        this.base2 = this.base1;
        this.variable2 = this.variable1;
        this.timeType2 = this.timeType1;
        this.dateRangeStart2 = this.dateRangeStart;
        this.processType2 = this.processType1;
        this.$nextTick(() => {
          this.processSubType2 = this.processSubType1;
        });
        this.base2 = this.base1;
        this.showSecondRow = true;
      } else {
        this.showSecondRow = false;
      }
      this.$store.state.parameterStripe.compare = this.compare;
      console.warn("compare changed:", val);
    },
    viewType: function () {
      this.$store.state.parameterStripe.viewType = this.viewType;
    },
    modelType: function () {
      this.$store.state.parameterStripe.modelType = this.modelType;
      let actualVariableMap = this.variableMap
        .get(this.viewType)
        .get(this.modelType);
      if (!actualVariableMap.has(this.variable1)) {
        let variable_notation_array = Array.from(actualVariableMap.keys());
        this.variable1 = variable_notation_array[0];
      }
      if (!actualVariableMap.has(this.variable2)) {
        let variable_notation_array = Array.from(actualVariableMap.keys());
        this.variable2 = variable_notation_array[0];
      }
      var extentName;
      if (this.modelType == "city") {
        extentName = "Budapest";
        this.$store.state.parameterStripe.felbontas = "BPK00";
        this.base1 = "BP";
        this.base2 = "BP";
      } else {
        extentName = "Magyarország";
        this.$store.state.parameterStripe.felbontas = "HUM000";
        this.base1 = "HU";
        this.base2 = "HU";
      }
      //this.$root.$refs.MapRef.changeExtent(extentName);
    },
    base1: function () {
      this.$store.state.parameterStripe.base1 = this.base1;
      this.$root.$refs.MapRef.setKozigLayerVisible(this.base1, 1);
      console.log("base1: " + this.base1);
    },
    base2: function () {
      this.$store.state.parameterStripe.base2 = this.base2;
      this.$root.$refs.MapRef.setKozigLayerVisible(this.base2, 2);
      console.log("base2: " + this.base2);
    },
  },
  computed: {
    definitionQuery1() {
      return this.$store.state.parameterStripe.raster_name_1;
    },
  },
  beforeMount() {
    this.qSubTypeMap.set("1", "Várható érték minimuma");
    this.qSubTypeMap.set("q_1", "Várható érték minimuma");
    this.qSubTypeMap.set("2", "25");
    this.qSubTypeMap.set("3", "Várható érték mediánja");
    this.qSubTypeMap.set("q_3", "Várható érték mediánja");
    this.qSubTypeMap.set("4", "75");
    this.qSubTypeMap.set("5", "Várható érték maximuma");
    this.qSubTypeMap.set("q_5", "Várható érték maximuma");
    this.qSubTypeMap.set("c_1", "Változás minimuma");
    this.qSubTypeMap.set("c_3", "Változás mediánja");
    this.qSubTypeMap.set("c_5", "Változás maximuma");
    this.loadConfigTables();
  },
  mounted() {
    var self = this;
    this.$store.state.parameterStripe.reEnablePrint = function () {
      self.isPrintButtonDisabled = false;
    };
  },
  methods: {
    print() {
      this.isPrintButtonDisabled = true;
      this.$root.$refs.MapRef.printWithGeoProc(this.definitionQuery1 + ".tif");
    },
    saveGeoTiff() {
      let rasterName = this.definitionQuery1;
      loadModules(["esri/tasks/QueryTask", "esri/tasks/query"]).then(
        ([QueryTask, Query]) => {
          var queryTask = new QueryTask(config.imageService.teszt);
          queryTask.on("complete", processSuccess);
          queryTask.on("error", handleError);
          var query = new Query();
          query.outFields = ["*"];
          query.where = "name = '" + this.definitionQuery1 + "'";
          queryTask.execute(query);
          function processSuccess(result) {
            console.table(result);
            let rasterID = result.featureSet.features[0].attributes.OBJECTID;
            let rasterURL =
              config.imageService.teszt +
              "/download?rasterIds=" +
              rasterID +
              "&geometry=&geometryType=esriGeometryEnvelope&format=&f=json";
            axios.get(rasterURL).then((response) => {
              const link = document.createElement("a");
              //Itt a letöltés url rossz az AG1081-en
              let url = response.data.rasterFiles[0].id;
              if (url.startsWith(".\\")) {
                url = url.replace(".\\", config.rasterDownloadUrlStart);
              }
              link.href = url; //url.replace("https//", "https://");
              link.target = "_blank";
              link.download = rasterName + ".tif";
              //link.setAttribute("download", fileName); //or any other extension
              document.body.appendChild(link);
              link.click();
            });
          }
          function handleError() {}
        },
      );
    },
    saveRasterImage(layerId) {
      var defQuery;
      var rasterfunction;
      var bbox;
      var imageSize;
      if (layerId == 1) {
        defQuery = this.definitionQuery1;
        rasterfunction = this.$store.state.parameterStripe
          .variable1_raster_function;
      } else {
        defQuery = this.definitionQuery2;
        rasterfunction = this.$store.state.parameterStripe
          .variable2_raster_function;
      }
      if (this.modelType == "city") {
        bbox = "2106841.562%2C5996000.001%2C2153722.298%2C6044592.547";
        imageSize = "1200%2C1200";
      } else {
        bbox =
          "1786677.827232041%2C5716135.59551849%2C2556247.8407667093%2C6215681.042900643";
        imageSize = "1920%2C1000";
      }
      let url =
        //"https://dev92-pc:6443/arcgis/rest/services/Meteorologia/teszt/ImageServer" +
        config.imageService.teszt +
        "/exportImage?bbox=" +
        bbox +
        "&bboxSR=&size=" +
        imageSize +
        "&imageSR=&time=&format=jpgpng&pixelType=UNKNOWN&noData=&noDataInterpretation=esriNoDataMatchAny&interpolation=RSP_NearestNeighbor&compression=&compressionQuality=&bandIds=&sliceId=&mosaicRule=%7B%22mosaicMethod%22+%3A+%22esriMosaicNone%22%2C%0D%0A+%22where%22+%3A+%22Name%3D%27" +
        defQuery +
        //"OBS_tx_19712000_SON_o_0_HU" +
        "%27%22%0D%0A%7D&renderingRule=%7B%22rasterFunction%22%3A%22" +
        rasterfunction +
        //"test" +
        "%22%7D&adjustAspectRatio=true&lercVersion=1&compressionTolerance=&f=json";
      axios.get(url).then((response) => {
        console.log(response);
        //const url = window.URL.createObjectURL(response.data.href);
        var fileName = this.definitionQuery1 + ".png";
        const link = document.createElement("a");
        link.href = response.data.href;
        link.target = "_blank";
        link.download = fileName;
        //link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    layer2CountyClicked() {
      this.base2 = "county";
    },
    layer2RegionClicked() {
      this.base2 = "region";
    },
    loadConfigTables() {
      let conf = config;
      console.log("config");
      console.log(conf);
      let url = config.config_tables.url;

      let map_city_model_code = config.config_tables.map_city_model;
      let map_climate_model_code = config.config_tables.map_climate_model;
      let table_city_model_code = config.config_tables.table_city_model;
      let table_climate_model_code = config.config_tables.table_climate_model;

      let query_string =
        "/query?where=1%3D1&orderByFields=display_order+ASC&outFields=*&f=pjson";
      let map_city_model_promise = axios.get(
        url + map_city_model_code + query_string,
      );
      let map_climate_model_promise = axios.get(
        url + map_climate_model_code + query_string,
      );
      let table_city_model_promise = axios.get(
        url + table_city_model_code + query_string,
      );
      let table_climate_model_promise = axios.get(
        url + table_climate_model_code + query_string,
      );

      Promise.all([
        map_city_model_promise,
        map_climate_model_promise,
        table_city_model_promise,
        table_climate_model_promise,
      ])
        .then((returnValues) => {
          console.log(returnValues);
          //Itt kellene feldolgozni a konfigurációt
          let map_city_json = returnValues[0];
          let map_climate_json = returnValues[1];
          let table_city_json = returnValues[2];
          let table_climate_json = returnValues[3];
          let variable_map = new Map();
          let map_hashmap = new Map();
          let table_hashmap = new Map();

          /*let map_city_hashmap = new Map();
          let map_climate_hashmap = new Map();
          let table_city_hashmap = new Map();
          let table_climate_hashmap = new Map();*/
          variable_map.set("mapView", map_hashmap);
          variable_map.set("graphView", table_hashmap);

          map_hashmap.set("city", new Map());
          map_hashmap.set("climate", new Map());
          table_hashmap.set("city", new Map());
          table_hashmap.set("climate", new Map());

          map_city_json.data.features.forEach((variable) =>
            variable_map
              .get("mapView")
              .get("city")
              .set(variable.attributes.variable_notation, variable.attributes),
          );
          map_climate_json.data.features.forEach((variable) =>
            variable_map
              .get("mapView")
              .get("climate")
              .set(variable.attributes.variable_notation, variable.attributes),
          );
          table_city_json.data.features.forEach((variable) =>
            variable_map
              .get("graphView")
              .get("city")
              .set(variable.attributes.variable_notation, variable.attributes),
          );
          table_climate_json.data.features.forEach((variable) =>
            variable_map
              .get("graphView")
              .get("climate")
              .set(variable.attributes.variable_notation, variable.attributes),
          );
          console.log("variable_map_");
          console.log(variable_map);
          this.variableMap = variable_map;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  data() {
    return {
      isPrintButtonDisabled: false,
      modelType: "climate",
      viewType: "mapView",
      mode1: "probability",
      mode2: "probability",
      //paramProbability1: "5",
      //paramProbability2: "5",
      //paramDifference1: "min",
      //paramDifference2: "min",
      base1: "HU",
      base2: "HU",
      variable1: null,
      variable2: null,
      variableOptions: [],
      variableMap: new Map(),
      timeType1: null,
      timeType2: null,
      processType1: null,
      processType2: null,
      processSubType1: null,
      processSubType2: null,
      aggregationModeForGraph: undefined,
      dateRangeStart: 1971,
      dateRangeStart2: 1971,
      qSubTypeMap: new Map(),
      dateRangeOptions: {
        dotSize: 14,
        width: "auto",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        dataLabel: "label",
        dataValue: "value",
        min: 1971,
        max: 2071,
        interval: 10,
        disabled: false,
        clickable: true,
        duration: 0.3,
        adsorb: false,
        lazy: false,
        tooltip: "active",
        tooltipPlacement: "bottom",
        tooltipFormatter: (start) => start + "-" + (start + 29), //void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: true,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
      timeSliderTooltipFormatter: (start) => start + "-" + (start + 29),
      timeOptions: [
        {
          value: "ann",
          text: "Éves",
        },
        {
          text: "Évszakos",
          options: [
            {
              value: "MAM",
              text: "Tavasz",
            },
            {
              value: "JJA",
              text: "Nyár",
            },
            {
              value: "SON",
              text: "Ősz",
            },
            {
              value: "DJF",
              text: "Tél",
            },
          ],
        },
        {
          value: "month",
          text: "Havi",
          options: [
            {
              value: "01",
              text: "Január",
            },
            {
              value: "02",
              text: "Február",
            },
            {
              value: "03",
              text: "Március",
            },
            {
              value: "04",
              text: "Április",
            },
            {
              value: "05",
              text: "Május",
            },
            {
              value: "06",
              text: "Június",
            },
            {
              value: "07",
              text: "Július",
            },
            {
              value: "08",
              text: "Augusztus",
            },
            {
              value: "09",
              text: "Szeptember",
            },
            {
              value: "10",
              text: "Október",
            },
            {
              value: "11",
              text: "November",
            },
            {
              value: "12",
              text: "December",
            },
          ],
        },
      ],
      annual: {
        value: "ann",
        text: "Éves",
      },
      seasonal: {
        text: "Évszakos",
        options: [
          {
            value: "MAM",
            text: "Tavasz",
          },
          {
            value: "JJA",
            text: "Nyár",
          },
          {
            value: "SON",
            text: "Ősz",
          },
          {
            value: "DJF",
            text: "Tél",
          },
        ],
      },
      monthly: {
        value: "month",
        text: "Havi",
        options: [
          {
            value: "01",
            text: "Január",
          },
          {
            value: "02",
            text: "Február",
          },
          {
            value: "03",
            text: "Március",
          },
          {
            value: "04",
            text: "Április",
          },
          {
            value: "05",
            text: "Május",
          },
          {
            value: "06",
            text: "Június",
          },
          {
            value: "07",
            text: "Július",
          },
          {
            value: "08",
            text: "Augusztus",
          },
          {
            value: "09",
            text: "Szeptember",
          },
          {
            value: "10",
            text: "Október",
          },
          {
            value: "11",
            text: "November",
          },
          {
            value: "12",
            text: "December",
          },
        ],
      },
      compare: false,
      showSecondRow: false,
      /*optionsX: ['list', 'of', 'options'],
      valueX:null*/
    };
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.padded {
  padding: 10px;
  width: 150px;
}
.dropdown {
  color: #2c3e50;
  padding: 0;
  margin: 0;
}
.downloadButton {
  /*background-color: #28a745;
  border-color: #28a745;*/
  color: white;
  font-size: 1.25rem;
  flex-grow: 0;
}
button:hover {
  /*background-color: #28a745;
  border-color: #28a745;*/
}
button:focus {
  /*background-color: #28a745;
  border-color: #28a745;*/
}
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  /*background-color: #28a745;
  border-color: #28a745;*/
}

.rasterCard {
  flex-grow: 1;
}
#RasterParameterContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.rangeSlider {
  flex-grow: 1;
}
.graphDownload {
  flex-grow: 0;
}
.baseGroup {
  flex-grow: 0;
}

.variableList {
  flex-grow: 1;
}

.timeTypeList {
  flex-grow: 1;
}

.processTypeList {
  flex-grow: 0;
}

.processSubTypeList {
  flex-grow: 1;
}

.rightPlaceHolder {
  flex-basis: calc(50vw - 13px);
  flex-grow: 0;
}
.outPdfLink {
  margin-left: 5px !important;
  margin-top: 6px !important;
  font-size: 1.25em;
  text-decoration: underline;
}
.nyomtat {
  position: fixed;
  right: 20px;
  top: 170px;
  font-size: 1.25em;
  z-index: 100000000;
}
#saveDropdown {
  position: fixed;
  right: 20px;
  top: 170px;
  font-size: 1.25em;
  z-index: 100000000;
  height: 28.25px !important;
}
/*.custom-select-lg {
   
    padding-left: 2px!important; 
}*/
>>> .tooltip-inner {
  background-color: white;
  color: black;
  border: 1px solid;
  border-color: black;
  font-size: 1.25em;
}
>>> .vue-slider-dot-tooltip-inner {
  color: black !important;
  border: 1px solid;
  /*border-radius: 3px;*/
  border-color: black !important;
  background-color: white !important;
  font-size: 1.25em;
}
</style>
